import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import signalService from '../services/signalService';

/**
 * heyportal.app/p/{code} — the link on a shared Portal card. Resolves the code and lands on the
 * Portal page in its place, so Back returns to wherever the link was opened from.
 */
export default function PortalShortLinkPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    let done = false;
    signalService.byCode(code).then((r) => {
      if (done) return;
      if (r?.success && r.data?.eventId) navigate(`/portals/${r.data.eventId}`, { replace: true });
      else setMissing(true);
    });
    return () => { done = true; };
  }, [code, navigate]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-black px-6 text-center font-mono text-white" data-testid="short-link">
      {missing ? (
        <>
          <p className="font-bold uppercase" style={{ fontSize: 14, letterSpacing: '0.14em' }}>No Portal at that link.</p>
          <p className="mt-2" style={{ fontSize: 11, letterSpacing: '0.1em', color: 'rgba(255,255,255,.6)' }}>IT MAY HAVE CLOSED, OR THE LINK IS MISSING A LETTER.</p>
          <button type="button" onClick={() => navigate('/featured', { replace: true })} className="mt-6 h-11 rounded-full bg-white px-6 font-bold uppercase text-black" style={{ fontSize: 12, letterSpacing: '0.14em' }}>See what’s on</button>
        </>
      ) : (
        <p className="font-bold uppercase" style={{ fontSize: 11, letterSpacing: '0.16em', color: 'rgba(255,255,255,.6)' }}>Opening the Portal…</p>
      )}
    </div>
  );
}
